jQuery(document).ready( function($) {

    $(document).on("click", '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();

        var href_attr = $(this).attr('href');
        //separate string with '-'
        var href_str = href_attr.split("/");
        //separate string with '-'
        var all_str = href_str[href_str.length-1].split("-");
        var package_str = all_str[0].split("_");

        var package_name = "";
        for (var i=0; i<package_str.length; i++) {
            var lower = package_str[i];
            var upper = lower.charAt(0).toUpperCase() + lower.substr(1);
            package_name += upper + ' ';
        }

        for (var i=0; i<all_str.length; i++) {
            var lower = all_str[i];
            var upper = lower.charAt(0).toUpperCase() + lower.substr(1);
            all_str[i] = upper;
        }
        //get name of page except size and '.jpg'
        if(all_str.length == 4){//just in case for the 'case study' page
          var template_name = package_name + all_str[all_str.length-3] + ' ' + all_str[all_str.length-2] + ' Page';
        }
        else if(all_str.length == 3){
          var template_name = package_name + all_str[all_str.length-2] + ' Page';
        }
        //get last item with .jpg (the size of image)
        var size_jpg = all_str[all_str.length-1];
        //separate image size and type of image file
        var size_str = size_jpg.split(".");
        //separate image size to width and height
        var size = size_str[0].split("x");
        //get width and height from size array
        var width = parseInt(size[0]);
        var height = parseInt(size[1]);
        var titleHeight = 50;
        var paddingBottom = 30;

        $(this).ekkoLightbox({
         type: 'image',
         onContentLoaded: function() {
           var container = $('.modal-content');
           container.css('height', height+titleHeight+paddingBottom);
           container.css('width', width);

           $('.modal-title').text(template_name);
           var container = $('.ekko-lightbox-container');
           var image = container.find('img');
           image.css('height', height);
           image.css('width', width);
           image.focus();
         }
       });
    });
    
});
